import { getAPIHost } from "@/lib/env";

function normalizeApiHostToUrl(apiHost: string): URL | null {
  if (typeof window === "undefined") {
    return null;
  }

  if (apiHost.startsWith("http://") || apiHost.startsWith("https://")) {
    return new URL(apiHost);
  }

  if (apiHost.startsWith("/")) {
    return new URL(window.location.origin);
  }

  return new URL(`https://${apiHost}`);
}

export function buildWebSocketUrl(
  path: string,
  params: Record<string, string | number | undefined> = {},
): string {
  const apiUrl = normalizeApiHostToUrl(getAPIHost());
  if (!apiUrl) {
    return "";
  }

  const protocol = apiUrl.protocol === "https:" ? "wss:" : "ws:";
  const wsUrl = new URL(path, `${protocol}//${apiUrl.host}`);

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === "") {
      return;
    }
    wsUrl.searchParams.set(key, String(value));
  });

  return wsUrl.toString();
}

export function buildUserEventWsUrl(sessId?: string): string {
  if (!sessId) {
    return "";
  }
  return buildWebSocketUrl("/ws/user/event", {
    _t: sessId,
  });
}

export function buildImageGenerationWsUrl(sessId?: string): string {
  return buildWebSocketUrl("/ws/agent/image/generate", {
    _t: sessId,
  });
}

export function buildQrCodeStatusWsUrl(sessId?: string): string {
  if (!sessId) {
    return "";
  }
  return buildWebSocketUrl("/ws/qrcode/status", {
    sid: sessId,
  });
}
